import { kExternalStorageAccountsPath } from '@/constants/constants-api-paths'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { ConnectedAccountsListResponse, ConnectedAccountsListResponseSchema } from '@/settings/schemas/external-storage-schema'
import { kErrorCodeAuthError } from '@/constants/constants-error-codes'
import { getAuth } from 'firebase/auth'
import * as Sentry from '@sentry/browser'
import { nanoid } from 'nanoid'

export default async function getConnectedAccounts(): Promise<ConnectedAccountsListResponse> {
  const sentry_transaction_id = nanoid()

  try {
    const token = await getAuth().currentUser?.getIdToken()
    if (!token) throw Error(kErrorCodeAuthError)

    const requestOptions: RequestInit = {
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Transaction-Id': sentry_transaction_id,
        Authorization: `Bearer ${token}`,
      },
      method: 'GET',
    }

    const apiUrl = kPaxtonAppApiRESTBaseUrl() + kExternalStorageAccountsPath
    const response = await fetch(apiUrl, requestOptions)
    const data = await response.json()

    if (!response.ok) {
      Sentry.withScope((scope) => {
        scope.setTags({ transaction_id: sentry_transaction_id })
        Sentry.captureException(new Error(`Fetch error - status: ${response.status}, detail: ${JSON.stringify(data)}`), {
          extra: { requestUrl: apiUrl, response: JSON.stringify(response), data: JSON.stringify(data) },
        })
      })
      throw new Error(`Fetch error - status: ${response.status}, detail: ${JSON.stringify(data)}`)
    }

    return ConnectedAccountsListResponseSchema.parse(data)
  } catch (e) {
    Sentry.withScope((scope) => {
      scope.setTags({ transaction_id: sentry_transaction_id })
      Sentry.captureException(e, { extra: { onLine: navigator.onLine, cookieEnabled: navigator.cookieEnabled } })
    })
    throw e
  }
}
